type Bucket =
    | '0-25'
    | '26-50'
    | '51-75'
    | '76-100'
    | '101-125'
    | '126-150'
    | '151-175'
    | '176-200'
    | '201+';

export function getBucket(size: number): Bucket {
    // Doing Math.ceil will round up the result of size/25 to the nearest whole number which is greater than the result itself
    switch (Math.ceil(size / 25)) {
        case 1:
            return '0-25';

        case 2:
            return '26-50';

        case 3:
            return '51-75';

        case 4:
            return '76-100';

        case 5:
            return '101-125';

        case 6:
            return '126-150';

        case 7:
            return '151-175';

        case 8:
            return '176-200';

        default:
            return '201+';
    }
}
